import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const TourPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 lg:px-8 bg-gradient-to-b from-white to-[#f7fafc]">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-xs font-semibold text-[#718096] tracking-wider uppercase mb-4">
            STEP-BY-STEP GUIDE
          </p>
          <h1 className="text-5xl font-bold text-[#1a2b4a] mb-6">Complete Security Solutions Walkthrough</h1>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            Discover how our comprehensive security solutions work together to protect your business from consultation to ongoing support.
          </p>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          {/* Step 1 */}
          <div className="relative flex items-start mb-16">
            <div className="flex-shrink-0 w-20 h-20 bg-[#1a2b4a] rounded-full flex items-center justify-center text-white text-2xl font-bold z-10">
              1
            </div>
            <div className="ml-8 flex-1">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">Initial Consultation &amp; Assessment</h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  We begin with a comprehensive consultation to understand your security needs, property layout, and specific concerns. Our experts conduct a thorough site assessment to identify vulnerabilities and recommend the most effective security solutions.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">What We Evaluate</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Property size and layout</li>
                      <li>• Entry and exit points</li>
                      <li>• High-risk areas</li>
                      <li>• Existing security infrastructure</li>
                    </ul>
                  </div>
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Deliverables</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Security assessment report</li>
                      <li>• Risk analysis</li>
                      <li>• Recommended solutions</li>
                      <li>• Preliminary cost estimate</li>
                    </ul>
                  </div>
                </div>
                <img
                  src="https://public.readdy.ai/ai/img_res/9183fcc825a2a51698b454807e7f7dc2.jpg"
                  alt="Consultation"
                  className="w-full h-64 object-cover rounded-lg mt-6"
                />
              </div>
            </div>
            <div className="absolute left-10 top-20 bottom-0 w-0.5 bg-gradient-to-b from-[#4a90e2] to-transparent" style={{ height: 'calc(100% + 4rem)' }}></div>
          </div>

          {/* Step 2 */}
          <div className="relative flex items-start mb-16">
            <div className="flex-shrink-0 w-20 h-20 bg-[#1a2b4a] rounded-full flex items-center justify-center text-white text-2xl font-bold z-10">
              2
            </div>
            <div className="ml-8 flex-1">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">Custom System Design</h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Based on the assessment, we design a customized security system tailored to your specific requirements. Our engineers create detailed plans showing camera placements, access control points, and system integration strategies.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Design Components</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Camera coverage maps</li>
                      <li>• Access control zones</li>
                      <li>• Network infrastructure</li>
                      <li>• Integration architecture</li>
                    </ul>
                  </div>
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Technical Specs</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Equipment specifications</li>
                      <li>• Storage requirements</li>
                      <li>• Bandwidth calculations</li>
                      <li>• Power requirements</li>
                    </ul>
                  </div>
                </div>
                <img
                  src="https://readdy.ai/api/search-image?query=Security%20system%20blueprint%20and%20technical%20drawings%20on%20white%20desk%20with%20modern%20laptop%20showing%203D%20building%20layout%2C%20professional%20engineering%20design%20documents%20with%20camera%20placement%20diagrams%2C%20clean%20bright%20workspace%20with%20technical%20planning%20materials%2C%20architectural%20security%20design%20visualization&width=900&height=400&seq=tour-step2-design&orientation=landscape"
                  alt="System Design"
                  className="w-full h-64 object-cover rounded-lg mt-6"
                />
              </div>
            </div>
            <div className="absolute left-10 top-20 bottom-0 w-0.5 bg-gradient-to-b from-[#4a90e2] to-transparent" style={{ height: 'calc(100% + 4rem)' }}></div>
          </div>

          {/* Step 3 */}
          <div className="relative flex items-start mb-16">
            <div className="flex-shrink-0 w-20 h-20 bg-[#1a2b4a] rounded-full flex items-center justify-center text-white text-2xl font-bold z-10">
              3
            </div>
            <div className="ml-8 flex-1">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">Professional Installation</h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Our certified technicians handle the complete installation process with minimal disruption to your operations. We ensure all equipment is properly mounted, configured, and tested for optimal performance.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Installation Process</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Equipment mounting</li>
                      <li>• Cable routing and management</li>
                      <li>• Network configuration</li>
                      <li>• System integration</li>
                    </ul>
                  </div>
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Quality Assurance</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Camera angle verification</li>
                      <li>• Recording quality testing</li>
                      <li>• Access control validation</li>
                      <li>• System performance check</li>
                    </ul>
                  </div>
                </div>
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20security%20camera%20on%20white%20wall%20in%20modern%20office%20building%2C%20wearing%20uniform%20and%20using%20professional%20tools%2C%20clean%20bright%20environment%20showing%20careful%20installation%20work%2C%20high-quality%20security%20equipment%20being%20mounted%20with%20precision%20and%20expertise&width=900&height=400&seq=tour-step3-installation&orientation=landscape"
                  alt="Installation"
                  className="w-full h-64 object-cover rounded-lg mt-6"
                />
              </div>
            </div>
            <div className="absolute left-10 top-20 bottom-0 w-0.5 bg-gradient-to-b from-[#4a90e2] to-transparent" style={{ height: 'calc(100% + 4rem)' }}></div>
          </div>

          {/* Step 4 */}
          <div className="relative flex items-start mb-16">
            <div className="flex-shrink-0 w-20 h-20 bg-[#1a2b4a] rounded-full flex items-center justify-center text-white text-2xl font-bold z-10">
              4
            </div>
            <div className="ml-8 flex-1">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">Training &amp; Handover</h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  We provide comprehensive training for your staff on how to use and manage the security systems effectively. Our team ensures everyone is comfortable with the technology and understands all features and capabilities.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Training Topics</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• System operation basics</li>
                      <li>• Live monitoring procedures</li>
                      <li>• Playback and search functions</li>
                      <li>• Alert management</li>
                    </ul>
                  </div>
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Documentation</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• User manuals</li>
                      <li>• Quick reference guides</li>
                      <li>• System diagrams</li>
                      <li>• Troubleshooting tips</li>
                    </ul>
                  </div>
                </div>
                <img
                  src="https://readdy.ai/api/search-image?query=Security%20system%20training%20session%20in%20bright%20modern%20office%20with%20instructor%20showing%20security%20monitoring%20software%20on%20large%20screen%20to%20attentive%20staff%20members%2C%20professional%20training%20environment%20with%20computers%20and%20displays%2C%20clean%20white%20interior%20with%20collaborative%20learning%20atmosphere&width=900&height=400&seq=tour-step4-training&orientation=landscape"
                  alt="Training"
                  className="w-full h-64 object-cover rounded-lg mt-6"
                />
              </div>
            </div>
            <div className="absolute left-10 top-20 bottom-0 w-0.5 bg-gradient-to-b from-[#4a90e2] to-transparent" style={{ height: 'calc(100% + 4rem)' }}></div>
          </div>

          {/* Step 5 */}
          <div className="relative flex items-start">
            <div className="flex-shrink-0 w-20 h-20 bg-[#1a2b4a] rounded-full flex items-center justify-center text-white text-2xl font-bold z-10">
              5
            </div>
            <div className="ml-8 flex-1">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4">Ongoing Support &amp; Maintenance</h3>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Our relationship doesn't end after installation. We provide continuous support, regular maintenance, and system updates to ensure your security infrastructure remains effective and up-to-date.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Support Services</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• 24/7 technical support</li>
                      <li>• Remote diagnostics</li>
                      <li>• Emergency response</li>
                      <li>• System optimization</li>
                    </ul>
                  </div>
                  <div className="bg-[#f7fafc] rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-[#1a2b4a] mb-2">Maintenance Plans</h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Regular system checks</li>
                      <li>• Software updates</li>
                      <li>• Equipment cleaning</li>
                      <li>• Performance reports</li>
                    </ul>
                  </div>
                </div>
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20security%20technician%20performing%20maintenance%20check%20on%20security%20equipment%20in%20modern%20bright%20facility%2C%20using%20diagnostic%20tools%20and%20laptop%20for%20system%20monitoring%2C%20clean%20white%20environment%20showing%20ongoing%20support%20and%20technical%20service%2C%20professional%20maintenance%20work%20atmosphere&width=900&height=400&seq=tour-step5-support&orientation=landscape"
                  alt="Support"
                  className="w-full h-64 object-cover rounded-lg mt-6"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 lg:px-8 bg-gradient-to-b from-white to-[#f7fafc]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#1a2b4a] rounded-2xl p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Ready to Implement Your Security Solution?
            </h2>
            <p className="text-base text-white/90 mb-8">
              Let's start with a free consultation to assess your needs and design the perfect security system for your property.
            </p>
            <Link
              to="/contact#consultation"
              className="inline-block bg-white text-[#1a2b4a] px-8 py-3 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Schedule Your Consultation
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TourPage;
